
<!-- Form -->
<ng-container *ngIf="invitationForm">
    <div class="no-benefits p-20">
        <div class="d-flex">
        <div class="font-14 m-b-10">
            Este beneficio es Exclusivo para miembros de la comunidad 
            <br>
            <img [src]="community?.imageUrl" style="width: 30px; height: 30px;">
            <b class="m-l-10">{{community?.name}}</b>
        </div>
    </div>
        <div class="text-center font-b1">
            {{communityForm?.name}}
        </div>
        <div class="text-center text-muted font-c2 m-t-10">
            <span *ngIf="!isExpanded && communityForm.description.length > 150">{{ communityForm.description | slice:0:150 }}...</span>
            <span *ngIf="isExpanded || communityForm.description.length <= 150">{{ communityForm.description }}</span>
            <a *ngIf="communityForm.description.length > 150" href="javascript:void(0)" (click)="toggleView()">
                {{ isExpanded ? 'Ver menos' : 'Ver más' }}
            </a>
        </div>

        <!-- Questions form-->
        <div *ngIf="communityForm?.questions?.length > 0">

            <div class="text-center font-c2 m-t-16">
                Respondé a estas preguntas para que los administradores tengan más información sobre ti. Solo ellos podrán ver tus
                respuestas.
            </div>

            <!-- Questions form-->
            <div class="m-t-24">

                <form [formGroup]="invitationForm" (ngSubmit)="onSendCommunityRequest()">
                    <div class="row" formArrayName="dynamicInputs">
                        <div *ngFor="let input of dynamicInputs?.controls; let i=index" [formGroupName]="i" class="col-12 form-group">
                            <label class="font-l1">{{i+1}}. {{ communityForm.questions[i].question }}</label>
                            <input class="form-control" formControlName="value" placeholder="">
                        </div>
                    </div>

                    <!-- button submit -->
                    <div class="form-group text-center m-t-20">
                        <button class="btn btn-primary w-100" [style.--colorTheme]="community.colorTheme" type="submit"
                            [disabled]="invitationForm?.invalid" style="padding: 10px 20px !important;">ENVIAR</button>
                    </div>
                </form>
            </div>
        </div>

        <!-- NO Questions form-->
        <div *ngIf="!communityForm?.questions?.length">

            <div class="text-center m-t-24">
                <button class="btn btn-primary w-100" [style.background-color]="community.colorTheme" style="padding: 10px 20px !important;"
                    (click)="onSendCommunityRequest()">
                    {{communityForm?.isAutoApproval ? 'Unirme a la Comunidad' : 'ENVIAR SOLICITUD'}}
                </button>
            </div>
        </div>
    </div>
</ng-container>